(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire0d69"];
var parcelRegister = parcelRequire.register;
parcelRegister("3JJf3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b88ab280653d43d$export$2e2bcd8739ae039; });
var $2b88ab280653d43d$var$filterBar = function() {
    $(".c-filters__label").click(function() {
        $(this).next(".c-filters__filters").slideToggle();
    });
};
var $2b88ab280653d43d$export$2e2bcd8739ae039 = $2b88ab280653d43d$var$filterBar;

});

})();
//# sourceMappingURL=filter-bar.1517ef09.js.map
